import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";
import Constants from "../../Action/Constants";
import { UnitInterface } from "../../Entity/Entities/Unit/UnitInterface";
import { PropertyInterface } from "../../Entity/Entities/Property/PropertyInterface";
import { ChargeInterface } from "../../Entity/Entities/Charge/ChargeInterface";
import { EventInterface } from "../../Entity/Entities/Event/EventInterface";

class TaskCreateWillMount extends Middleware implements MiddlewareInterface {

  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    this.component.session = this.component.props.app.session.user;
    this.component.person = this.component.props.app.persons.filter(
      person => person.id === this.component.session.id
    )[0];

    this.component.props.dispatch({
      type: Constants.GLOBAL_EVENT_CREATE_CLEAR
    });

    const pageParams = {...this.component.props.component.params};

    if (!!pageParams.propertyId || !!pageParams.unitId || !!pageParams.chargeId || !!pageParams.eventId) {
      this.component.setState({
        disableObjectField: true
      });
    }

    if (!!pageParams.propertyId) {
      const property: PropertyInterface = this.component.props.properties.byId[pageParams.propertyId];

      this.component.setState({
        selectedEntityForTask: property,
        executorId: property.manager && property.manager.id
      })
    }

    if (!!pageParams.unitId) {
      const unit: UnitInterface = this.component.props.units.byId[pageParams.unitId];

      this.component.setState({
        selectedEntityForTask: unit,
        executorId: unit.property && unit.property.manager && unit.property.manager.id,
        reporterId: unit.getActiveContract() && unit.getActiveContract().person && unit.getActiveContract().person.id
      })
    }

    if (!!pageParams.chargeId) {
      this.component.props.dispatch({
        type: Constants.GLOBAL_CHARGE_FOR_CHARGE_DETAILS_PAGE,
        payload: {
          chargeId: pageParams.chargeId,
        },
        onSuccess: (charge: ChargeInterface) => {
          this.component.setState({
            selectedEntityForTask: charge
          })
        }
      })
    }

    if (!!pageParams.eventId) {
      this.component.props.dispatch({
        type: Constants.GLOBAL_EVENT_FOR_EVENT_DETAILS_PAGE,
        payload: {
          eventId: pageParams.eventId,
        },
        onSuccess: (event: EventInterface) => {
          this.component.setState({
            selectedEntityForTask: event
          })
        }
      })
    }

    if (Object.keys(this.component.props.app?.savedDataBeforeRedirecting || {}).length > 0) {
      const createdExecutor = this.component.props.app.savedDataBeforeRedirecting.executor &&
        this.component.props.app.savedDataBeforeRedirecting.executor;

      const createdReporter = this.component.props.app.savedDataBeforeRedirecting.reporter &&
        this.component.props.app.savedDataBeforeRedirecting.reporter;

      const state = {
        ...this.component.props.app.savedDataBeforeRedirecting.taskCreateDataToBeSaved,
      };

      if (!!createdExecutor) {
        state.executorId = createdExecutor.id;
      }

      if (!!createdReporter) {
        state.reporterId = createdReporter.id;
      }

      this.component.setState({
        ...state
      });
    }
  }
}

export default new TaskCreateWillMount();
